import { LineItemKey, UpdateProductOptions } from '../../store/api';

export const mapLineItemKey = (product: UpdateProductOptions): LineItemKey => {
    return {
        productId: product.id,
        usageCondition: product.price
            ? {
                  lendingModel: product.price.lendingModel,
                  usageLimit: product.price.usageLimit,
                  termLimit: product.price.termLimit
              }
            : undefined,
        subscriptionPeriodType: product.subscriptionPeriod?.type
    };
};
